import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_popover = _resolveComponent("b-popover");
  return _openBlock(), _createBlock(_component_b_popover, {
    target: $props.target,
    click: $props.click,
    placement: $props.placement,
    show: $props.show,
    "custom-class": $options.customClass,
    container: $props.container,
    delay: $props.delay,
    triggers: $props.triggers,
    onShown: $options.onShown,
    onHidden: $options.onHidden
  }, {
    title: _withCtx(() => [_renderSlot(_ctx.$slots, "title")]),
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
    _: 3
  }, 8, ["target", "click", "placement", "show", "custom-class", "container", "delay", "triggers", "onShown", "onHidden"]);
}